export default __webpack_public_path__ + "static/media/1992.cf3e9c29.png";